import { useAnonymousAuthContext } from '../contexts/AnonymousAuthContext';

export const useAnonymousAuth = () => {
  return useAnonymousAuthContext();
};
